/**
 * E9. Бумаги: позиция видна сразу (это не азарт), сумма покупки ползунком
 * до всех сбережений, «Купить» и «Продать всё».
 */
import { t } from '@life/i18n';
import type { StocksInput, StocksState } from '@life/minigames';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Bet, betCap, useBet } from './ui/Bet';

export function Stocks({ state, life, onInput }: MinigameScreenProps<StocksInput, StocksState>) {
  const cap = betCap(state.maxAmount, life.money);
  const [sum, setSum] = useBet(cap);
  return (
    <>
      <p class="mono">{state.held > 0 ? t('ui.minigame.stocks.held', { sum: money(state.held) }) : t('ui.minigame.stocks.none')}</p>
      <Bet cap={cap} value={sum} onChange={setSum} label={t('ui.minigame.invest.sum')} />
      <div class="picks">
        <button type="button" class="btn accent" disabled={sum <= 0} onClick={() => onInput({ amount: sum })}>
          {t('ui.minigame.stocks.buy', { sum: money(sum) })}
        </button>
        {state.held > 0 && (
          <button type="button" class="btn" onClick={() => onInput({ sell: true })}>
            {t('ui.minigame.stocks.sell', { sum: money(state.held) })}
          </button>
        )}
      </div>
    </>
  );
}
